<template>
    <div class="container" :style="{'min-height': height+'px'}">
        <div class="tle">
            <router-link to="/user"><span><i class="iconfont">&#xe703;</i>申请学分</span></router-link>
        </div>
        <div class="content" v-if="data.length">
            <div class="cards" v-for="item in data" :key="item.id">
                <p><span class="key">报名人：</span><span class="value">{{item.name}}</span></p>
                <p><span class="key">凭证略缩图：</span><img :src="item.img_path | img_url_finish" class="slightly"  @click="imgView(item.img_path)"></p>
                <p><span class="key">上传时间：</span><span class="value">{{ item.create_time }}</span></p>
            </div>
        </div>
        <div v-else class="no-data">
            <img src="~mpic/no-favorite.png">
            <p>暂无数据</p>
        </div>
        <div class="view-url" v-if="showView" @click="showView = false">
            <img :src="viewUrl | img_url_finish">
        </div>
        <div class="option-div">
            <router-link to="/point" class="btn">申请学分</router-link>
        </div>
    </div>
</template>

<script>
import { getCreditList } from '../../../service'

export default {
    data(){
        return {
            height:0,
            data: [],
            viewUrl:'',
            showView: false
        }
    },
    computed: {
        user_key() {
            return this.$store.state.user_key
        }
    },
    methods:{
        async getList(){
            let res = await getCreditList({ user_key: this.user_key }, (error) => {this.$Message.error('请求错误!')})
            this.data = res.credit_list
        },

        imgView(url){
            this.viewUrl = url
            this.showView = true
        }
    },
    created(){
        this.getList()
    },
    mounted() {
      this.height = document.documentElement.clientHeight + ''
    }
}
</script>

<style lang="stylus" scoped>
@import '../styles/common.styl'

    .content
        margin-bottom: 2.05rem
        margin-top: 1.18rem
        .cards
            position: relative
            margin-top: .3rem
            line-height: .36rem
            padding: .27rem .35rem
            background: #ffffff
            border-radius: .1rem
            .slightly
                width:.94rem
                height:.94rem
                border-radius:.04rem
            .key
                color: #999999
            .value
                color: #333333
                font-weight: bold
            .red
                color: #E12222
            p + p
                margin-top:.25rem
    .view-url
        position: fixed
        left: 0
        right: 0
        top: 0
        bottom: 0
        background: #000000
        display: flex
        align-items: center
        z-index: 100
        img
            width: 100%
</style>
